import { Injectable } from '@angular/core';
import config from 'devextreme/core/config';

@Injectable()
export class RxntDevextremeLicenseService {
  private licenseKey = 'LCPv1,QS@3>Sp(j@bp+9o6J@9pje%!i->I%y:Z+!iei-tSJei%eR>IJ-QcHQB%Jm:%KmtVQVv6oR[:eQy,Qa<pJ!oS7<[!RSjIHtg9nRR,iR%!N3[><F!VJ!!Ze3J:b,B7ityc<4vS%VF(>,@7e3[:bS3eR!E%j4N(<-b7ja@%KFSpJ<4%>VepicmkpR<!K!<I%4!SQdQSj@vSKRF>Q4vpj!E9K!vpL4@2<tG>%X<2p@@!Q462b-v2%d)I<-@aQd@pg@@!Q4@2_@F!Qd:Ip!@I<4)aKz<I_y62<!6p<!Qp_y:6<4:>Q8vIbR)9jz;!jL;9jyFI7yFI7yFI9ll';
  // noinspection TypeScriptFieldCanBeMadeReadonly
  private configFunction: Function;

  constructor() {
    this.configFunction = config;
  }

  setLicense() {
    this.configFunction({ licenseKey: this.licenseKey });
  }
}
